import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Key, ArrowLeft } from "lucide-react";
import { toast } from "sonner";
import MiniFooter from "../components/MiniFooter";

export default function Login() {
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success("Bienvenido " + u.full_name);
      const dest = location.state?.from || (u.role === "super_admin" ? "/admin" : u.role === "seller" ? "/seller" : "/investor");
      navigate(dest);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Credenciales inválidas");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-zinc-50 flex flex-col">
      <header className="px-6 py-5 border-b border-zinc-200 bg-white">
        <Link to="/" className="flex items-center w-fit" data-testid="login-logo">
          <img src="/logo-brand.png" alt="DerechoLlave" className="h-14 w-auto" />
        </Link>
      </header>
      <main className="flex-1 flex items-center justify-center px-6 py-12">
        <div className="w-full max-w-md">
          <Link to="/" className="text-sm text-slate-500 inline-flex items-center gap-1 mb-6 hover:underline" data-testid="back-home">
            <ArrowLeft className="w-4 h-4" /> Volver al inicio
          </Link>
          <h1 className="font-display text-3xl font-extrabold tracking-tight">Bienvenido de vuelta</h1>
          <p className="text-slate-500 mt-2 text-sm">Ingresa para gestionar tus negocios o solicitudes.</p>

          <form onSubmit={submit} className="mt-8 space-y-4">
            <div>
              <Label htmlFor="email">Email</Label>
              <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" />
            </div>
            <div>
              <div className="flex items-center justify-between">
                <Label htmlFor="password">Contraseña</Label>
                <Link to="/forgot-password" className="text-xs font-semibold text-slate-700 hover:text-slate-900 hover:underline" data-testid="forgot-password-link">
                  ¿Olvidaste tu contraseña?
                </Link>
              </div>
              <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" />
            </div>
            <Button type="submit" disabled={loading} className="w-full btn-primary h-11" data-testid="login-submit">
              {loading ? "Ingresando..." : "Ingresar"}
            </Button>
          </form>

          <p className="text-center text-sm text-slate-500 mt-6">
            ¿Aún no tienes cuenta? <Link to="/register" className="font-semibold text-slate-900 hover:underline" data-testid="login-to-register">Regístrate</Link>
          </p>
        </div>
      </main>
      <MiniFooter />
    </div>
  );
}
